import { useTranslation } from "react-i18next";
import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import { CurrentOrder } from "@features/Order/CurrentOrder";
import { HistoryOrderList } from "@features/Order/HistoryOrderList";

export const OrderPage = () => {
    const { t } = useTranslation("order");

    return (
        <AccountDetailsLayout title={t("myOrders")}>
            <CurrentOrder />
            <HistoryOrderList />
        </AccountDetailsLayout>
    );
};
